<div class="portfolio-page font-sans pb-8">


<div class="max-w-[1400px] mx-auto px-5 sm:px-7 lg:px-10 pt-5 space-y-5">



<!-- HEADER -->

<div class="portfolio-header">


<div>

<h1>
{{ selectedService ? 'Portfolio: ' + selectedService.service_name : 'Portfolio' }}
</h1>


<p>
{{ selectedService ? 'Manage portfolio images and videos for this service.' : 'Select a service below to manage its portfolio images and videos.' }}
</p>


</div>




<button *ngIf="selectedService" class="secondary-btn mr-4" (click)="backToFolders()" style="margin-right: 15px; border: 1px solid #ccc; padding: 8px 16px; border-radius: 6px; cursor: pointer; background: #fff;">
<span class="material-symbols-outlined" style="vertical-align: middle; font-size: 18px; margin-right: 5px;">arrow_back</span>
Back
</button>

<button
class="upload-btn"
*ngIf="selectedService && !(merchantData?.subscriptionTier === 'STANDARD' && portfolio.length >= 20)"
(click)="openUpload()">


<span class="material-symbols-outlined">
add_photo_alternate
</span>


Upload Media


</button>
<div *ngIf="selectedService && merchantData?.subscriptionTier === 'STANDARD' && portfolio.length >= 20" style="color: #B01E3E; font-weight: 600;">
    Standard Plan limit (20) reached. <br>
    <a routerLink="/merchant/subscription" style="color: #B01E3E; text-decoration: underline;">Upgrade to Premium</a>
</div>




</div>







<!-- FOLDER VIEW -->
<div *ngIf="!selectedService" class="folders-grid">
    <div *ngFor="let svc of services" (click)="selectService(svc)" class="folder-card" style="border-radius: 12px; overflow: hidden; cursor: pointer; transition: transform 0.3s, box-shadow 0.3s; background: #fff; box-shadow: 0 4px 15px rgba(0,0,0,0.05); position: relative; aspect-ratio: 4/3;" onmouseover="this.style.transform='translateY(-5px)'; this.style.boxShadow='0 10px 25px rgba(0,0,0,0.1)'" onmouseout="this.style.transform='none'; this.style.boxShadow='0 4px 15px rgba(0,0,0,0.05)'">
        
        <div style="width: 100%; height: 100%; background-color: #f8f9fa;">
            <img *ngIf="svc.media && svc.media.length && svc.media[0].media_type === 'image'" [src]="imageBaseUrl + svc.media[0].media_url" style="width: 100%; height: 100%; object-fit: cover;">
            <video *ngIf="svc.media && svc.media.length && svc.media[0].media_type === 'video'" [src]="imageBaseUrl + svc.media[0].media_url" style="width: 100%; height: 100%; object-fit: cover;"></video>
            <div *ngIf="!svc.media || !svc.media.length" style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; background: #ffebee;">
                <span class="material-symbols-outlined" style="font-size: 64px; color: #B01E3E;">photo_library</span>
            </div>
        </div>

        <div style="position: absolute; bottom: 0; left: 0; width: 100%; padding: 40px 20px 20px; background: linear-gradient(to top, rgba(0,0,0,0.8), transparent); color: #fff; display: flex; flex-direction: column; justify-content: flex-end; box-sizing: border-box;">
            <div style="display: flex; align-items: center; justify-content: space-between;">
                <h3 style="margin: 0; font-size: 18px; font-weight: 600; color: #fff; text-shadow: 1px 1px 3px rgba(0,0,0,0.5); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 80%;">{{svc.service_name}}</h3>
                <span class="material-symbols-outlined" style="font-size: 18px; background: rgba(255,255,255,0.2); padding: 8px; border-radius: 50%; backdrop-filter: blur(4px);">folder_open</span>
            </div>
            <p style="margin: 5px 0 0; font-size: 13px; opacity: 0.9;">Manage portfolio</p>
        </div>
    </div>
    
    <div *ngIf="services.length === 0" style="grid-column: 1 / -1; text-align: center; padding: 40px; color: #777;">
        You haven't added any services yet. Please go to the Services menu to create a service first.
    </div>
</div>

<!-- FILTER -->

<div class="filter-section" *ngIf="selectedService">


<button
[class.active]="selectedFilter==='all'"
(click)="selectedFilter='all'">

All

</button>



<button
[class.active]="selectedFilter==='image'"
(click)="selectedFilter='image'">

Images

</button>




<button
[class.active]="selectedFilter==='video'"
(click)="selectedFilter='video'">

Videos

</button>


</div>









<!-- GALLERY -->


<div class="gallery-container" *ngIf="selectedService">



<div
class="gallery-grid"
*ngIf="portfolio.length">


<div
class="media-card"
*ngFor="let item of filteredPortfolio()">





<div class="media-preview">



<img
*ngIf="item.media_type==='image'"
[src]="imageBaseUrl + item.media_url">





<video
*ngIf="item.media_type==='video'"
controls>

<source
[src]="imageBaseUrl + item.media_url">

</video>






<div class="overlay">


<button
(click)="openMedia(imageBaseUrl + item.media_url, item.media_type)">

<span class="material-symbols-outlined">
visibility
</span>

</button>





<button
(click)="openEdit(item)">

<span class="material-symbols-outlined">
edit
</span>

</button>




<button
(click)="deletePortfolio(item._id)">

<span class="material-symbols-outlined">
delete
</span>

</button>


</div>



</div>








<!-- <div class="media-info">


<h3>
{{item.title}}
</h3>



<p class="description">

{{item.description}}

</p>





<div class="event-details">


<p>

<span class="material-symbols-outlined">
celebration
</span>

{{item.event_type}}

</p>




<p>

<span class="material-symbols-outlined">
location_on
</span>

{{item.event_location}}

</p>





<p>

<span class="material-symbols-outlined">
calendar_month
</span>

{{item.event_year}}

</p>


</div>



</div> -->





</div>



</div>









<div
class="empty-state"
*ngIf="portfolio.length===0">


<span class="material-symbols-outlined">

photo_library

</span>



<h3>
No portfolio items yet
</h3>


<p>
Upload your first wedding photo or video.
</p>



<button
(click)="openUpload()">

Upload Media

</button>



</div>



</div>








</div>








<!-- UPLOAD MODAL -->

<div
class="upload-modal"
*ngIf="showUpload">


<div class="modal-box">



<h2>

{{editMode?'Edit Portfolio':'Upload Portfolio'}}

</h2>





<!-- MEDIA CHANGE -->

<input
type="file"
multiple
[accept]="merchantData?.subscriptionTier === 'STANDARD' ? 'image/*' : 'image/*,video/*'"
(change)="selectFile($event)">
<small *ngIf="merchantData?.subscriptionTier === 'STANDARD'" style="color: #666; font-size: 12px; margin-top: 5px; display: block;">Videos not supported in Standard Plan.</small>







<div
class="preview-wrapper"
*ngIf="previewUrl">



<img
*ngIf="portfolioData.media_type==='image'"
[class.preview-image]="true"
[src]="previewUrl">





<video
*ngIf="portfolioData.media_type==='video'"
class="preview-image"
controls>


<source
[src]="previewUrl">


</video>


</div>











<div class="modal-actions">


<button
(click)="closeUpload()">

Cancel

</button>




<button
(click)="savePortfolio()">


{{editMode?'Update':'Upload'}}


</button>



</div>




</div>


</div>









<!-- IMAGE VIEWER -->


<div
class="image-viewer"
*ngIf="showImageViewer"
(click)="closeImage()">



<div
class="viewer-content"
(click)="$event.stopPropagation()">



<button
class="close-btn"
(click)="closeImage()">


<span class="material-symbols-outlined">
close
</span>


</button>




<img
*ngIf="selectedMediaType === 'image'"
[src]="selectedImage" style="max-width: 100%; max-height: 80vh;">

<video
*ngIf="selectedMediaType === 'video'"
[src]="selectedImage" controls autoplay style="max-width: 100%; max-height: 80vh;"></video>



</div>


</div>




</div>